import styles from './GeneralTabPanel.module.scss';

import clsx from 'clsx';
import { JSX } from 'react';

import { Panel } from '../../../../../components';

import {
  BookingsWithAutoDisable,
  General,
  LinkPreDocuments,
  Permit,
  Receipt,
  VendorAndCurrency,
} from './components';

type Props = {
  openPdfOverlay: () => void;
  filesPreviewNavigationComponent: JSX.Element;
};

export function GeneralTabPanel({
  openPdfOverlay,
  filesPreviewNavigationComponent,
}: Props) {
  return (
    <Panel restrictedWidth className={clsx(styles.panel)}>
      <General />
      <VendorAndCurrency />
      <Permit />
      <LinkPreDocuments />

      <Receipt
        openPdfOverlay={openPdfOverlay}
        navigation={filesPreviewNavigationComponent}
      />

      <BookingsWithAutoDisable />
    </Panel>
  );
}
